import React from "react";
import "./DisabledHint.css";

// Wraps a disabled button so hovering it says why. A disabled button gets no
// mouse events and browsers skip its title, so the message is drawn by the
// wrapper instead. No message, no hint.
const DisabledHint = ({ message, children }) => (
  <span className={`dm-hint${message ? " dm-hint-active" : ""}`} data-hint={message || undefined}>
    {children}
  </span>
);

export default DisabledHint;
